import * as React from 'react';
import {useSelector} from 'react-redux';

import {BackButton} from 'shells/button/back-button/back-button';
import {Button} from 'shells/button/button';
import {CloseButton} from 'shells/button/close-button/close-button';
import {RepeatIcon} from 'shells/icon';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Body} from 'shells/typography/body';
import {Warning} from 'shells/warning/warning';

import {getShouldDisplayAgentWarning, getWarningTextForAgent} from './helpers';
import type {AgentKey} from './helpers';
import {getAgentEntityContext} from './redux/agent-selectors';
import type {PageContext} from './redux/consts';

import styles from './team-ai-sidebar.module.css';

type Props = {
    title: string;
    subTitle: string | null | undefined;
    subHeaderIcon: React.ReactNode | null | undefined;
    onClose: () => void;
    onNavigateBack?: () => void;
    activeAgent: AgentKey | null | undefined;
    pageContextType: PageContext | null | undefined;
};

export function TeamAiHeader(props: Props) {
    const shouldDisplayAgentWarning = getShouldDisplayAgentWarning(
        props.activeAgent,
        props.pageContextType
    );
    const agentContext = useSelector(getAgentEntityContext);
    // @ts-expect-error
    const chatbot = agentContext && agentContext.chatbot;

    return (
        <div className={styles.header}>
            <div className='flex justify-center align-center full-height'>
                {props.onNavigateBack && (
                    <div className={styles['header-back-button']}>
                        {/* @ts-expect-error */}
                        <BackButton as='button' onClick={props.onNavigateBack} backText='Back' />
                    </div>
                )}
                <StackLegacy spacing={0} alignCenter={true}>
                    <StackLegacy isHorizontal={true} alignCenter={true} spacing={8}>
                        {shouldDisplayAgentWarning && (
                            <div className='mt-4'>
                                <Warning text={getWarningTextForAgent(props.activeAgent) || ''} />
                            </div>
                        )}
                        <Body size='large' isBold={true} color='dark'>
                            {props.title}
                        </Body>
                    </StackLegacy>
                    {props.subHeaderIcon && props.subTitle && (
                        <StackLegacy spacing={4} alignCenter={true} isHorizontal={true}>
                            <div className='mt-2'>{props.subHeaderIcon}</div>
                            <div className={styles['header-sub-title-container']}>
                                <Body
                                    size='small'
                                    truncate={{type: 'block'}}
                                    title={props.subTitle}
                                >
                                    {props.subTitle}
                                </Body>
                            </div>
                        </StackLegacy>
                    )}
                </StackLegacy>
                {props.onNavigateBack && (
                    <div className={styles['header-reset-button']}>
                        <Button
                            variant='text-secondary'
                            size='xlarge'
                            onClick={() => {
                                if (chatbot) {
                                    chatbot.resetConversation();
                                }
                            }}
                            noPadding={true}
                        >
                            <RepeatIcon />
                        </Button>
                    </div>
                )}
                <div className={styles['header-close-button']}>
                    <CloseButton variant='dark' onClick={props.onClose} />
                </div>
            </div>
        </div>
    );
}
